import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';

// Google Fonts: Noto Serif KR
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href =
  'https://fonts.googleapis.com/css2?family=Noto+Serif+KR:wght@300;400;500;600;700&family=Noto+Sans+KR:wght@300;400;500;600;700&display=swap';
if (!document.head.querySelector('link[href*="Noto+Serif+KR"]')) {
  document.head.appendChild(fontLink);
}

type FloorPlanType = {
  id: string;
  label: string;
  size: string;
  totalUnits: number;
  units: number;
  ratio: string;
  areas: {
    '전용면적': string;
    '공급면적': string;
    '공급면적발코니': string;
    '계약면적': string;
  };
  thumbnailImg: string;
  planImg: string;
};

const floorPlans: FloorPlanType[] = [
  {
    id: '59A',
    label: '59㎡ A',
    size: '59',
    totalUnits: 482,
    units: 78,
    ratio: '16.2%',
    areas: {
      '전용면적': '59.98㎡',
      '공급면적': '20.86㎡',
      '공급면적발코니': '87.44㎡',
      '계약면적': '136.56㎡',
    },
    thumbnailImg:
      'https://public.readdy.ai/ai/img_res/70379cf6e53b835db782d6560ee16bce.jpg',
    planImg:
      'https://static.readdy.ai/image/3b7ebc9e513f68fc027b047fbdd0fbe7/fb7bb913a66454b6b621a38386b67210.png',
  },
  {
    id: '59B',
    label: '59㎡ B',
    size: '59',
    totalUnits: 482,
    units: 92,
    ratio: '19.1%',
    areas: {
      '전용면적': '59.98㎡',
      '공급면적': '20.86㎡',
      '공급면적발코니': '87.44㎡',
      '계약면적': '136.56㎡',
    },
    thumbnailImg:
      'https://readdy.ai/api/search-image?query=apartment%20floor%20plan%20small%20thumbnail%20blueprint%20top%20view%2059sqm%20two%20bedroom%20B%20type%20layout%20architectural%20drawing%20dark%20navy%20background%20white%20lines%20minimal%20clean%20technical%20illustration&width=120&height=90&seq=thumb-59b-002&orientation=landscape',
    planImg:
      'https://static.readdy.ai/image/3b7ebc9e513f68fc027b047fbdd0fbe7/b5f5775d0a997aa97bd382defa659fab.png',
  },
  {
    id: '59C',
    label: '59㎡ C',
    size: '59',
    totalUnits: 482,
    units: 64,
    ratio: '13.3%',
    areas: {
      '전용면적': '59.98㎡',
      '공급면적': '20.86㎡',
      '공급면적발코니': '87.44㎡',
      '계약면적': '136.56㎡',
    },
    thumbnailImg:
      'https://readdy.ai/api/search-image?query=apartment%20floor%20plan%20small%20thumbnail%20blueprint%20top%20view%2059sqm%20two%20bedroom%20C%20type%20layout%20architectural%20drawing%20dark%20navy%20background%20white%20lines%20minimal%20clean%20technical%20illustration&width=120&height=90&seq=thumb-59c-003&orientation=landscape',
    planImg:
      'https://static.readdy.ai/image/3b7ebc9e513f68fc027b047fbdd0fbe7/e8b8a0248a4a30a4513ff40faacbdada.png',
  },
  {
    id: '84A',
    label: '84㎡ A',
    size: '84',
    totalUnits: 482,
    units: 88,
    ratio: '18.3%',
    areas: {
      '전용면적': '84.97㎡',
      '공급면적': '28.14㎡',
      '공급면적발코니': '118.22㎡',
      '계약면적': '182.45㎡',
    },
    thumbnailImg:
      'https://readdy.ai/api/search-image?query=apartment%20floor%20plan%20small%20thumbnail%20blueprint%20top%20view%2084sqm%20three%20bedroom%20A%20type%20layout%20architectural%20drawing%20dark%20navy%20background%20white%20lines%20minimal%20clean%20technical%20illustration&width=120&height=90&seq=thumb-84a-004&orientation=landscape',
    planImg:
      'https://static.readdy.ai/image/3b7ebc9e513f68fc027b047fbdd0fbe7/aa173174d2662941564f8e3c8fc1aebd.png',
  },
  {
    id: '84B',
    label: '84㎡ B',
    size: '84',
    totalUnits: 482,
    units: 96,
    ratio: '19.9%',
    areas: {
      '전용면적': '84.97㎡',
      '공급면적': '28.14㎡',
      '공급면적발코니': '118.22㎡',
      '계약면적': '182.45㎡',
    },
    thumbnailImg:
      'https://readdy.ai/api/search-image?query=apartment%20floor%20plan%20small%20thumbnail%20blueprint%20top%20view%2084sqm%20three%20bedroom%20B%20type%20layout%20architectural%20drawing%20dark%20navy%20background%20white%20lines%20minimal%20clean%20technical%20illustration&width=120&height=90&seq=thumb-84b-005&orientation=landscape',
    planImg:
      'https://static.readdy.ai/image/3b7ebc9e513f68fc027b047fbdd0fbe7/1e2d785332e6c0328ec252f887beea48.png',
  },
  {
    id: '84C',
    label: '84㎡ C',
    size: '84',
    totalUnits: 482,
    units: 64,
    ratio: '13.3%',
    areas: {
      '전용면적': '84.98㎡',
      '공급면적': '28.14㎡',
      '공급면적발코니': '118.22㎡',
      '계약면적': '182.45㎡',
    },
    thumbnailImg:
      'https://readdy.ai/api/search-image?query=apartment%20floor%20plan%20small%20thumbnail%20blueprint%20top%20view%2084sqm%20three%20bedroom%20C%20type%20layout%20architectural%20drawing%20dark%20navy%20background%20white%20lines%20minimal%20clean%20technical%20illustration&width=120&height=90&seq=thumb-84c-006&orientation=landscape',
    planImg:
      'https://static.readdy.ai/image/3b7ebc9e513f68fc027b047fbdd0fbe7/405f7176bc8c1d145e2feefcfdcccad1.png',
  },
];

export default function FloorPlanTypesPage() {
  const [selectedType, setSelectedType] = useState<string>('59B');
  const [enlarged, setEnlarged] = useState(false);

  const selectedPlan = floorPlans.find((p) => p.id === selectedType) ?? floorPlans[0];
  const typeLabel = selectedPlan.id.replace(selectedPlan.size, '');

  return (
    <>
      <Navigation />
      <div
        className="min-h-screen bg-white pt-16 md:pt-20"
        style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
      >
        {/* Hero Section */}
        <section
          className="relative h-[180px] md:h-[300px] flex items-center justify-center overflow-hidden"
          style={{ background: 'linear-gradient(135deg, #1a2a5e 0%, #0d1b3e 100%)' }}
        >
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://readdy.ai/api/search-image?query=architectural%20blueprint%20floor%20plan%20line%20drawing%20technical%20white%20lines%20on%20dark%20navy%20blue%20background%20geometric%20pattern%20building%20design%20top%20view%20minimal%20abstract&width=1920&height=300&seq=hero-floorplan-bg-001&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10 text-center text-white px-4">
            <h1
              className="text-xl md:text-5xl font-bold tracking-tight"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              평형안내
            </h1>
            <p className="mt-2 text-xs md:text-base text-white/70">
              다양한 가족 구성원을 위한 맞춤형 평면 설계
            </p>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="border-b border-gray-200 bg-white">
          <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-2 text-xs text-gray-500">
            <Link to="/" className="hover:text-gray-700 cursor-pointer">
              홈
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-700">평형안내</span>
          </div>
        </div>

        {/* Type Selector Section */}
        <section className="py-10 md:py-20 px-4 bg-white">
          <div className="max-w-5xl mx-auto">
            {/* 상단 레이블 */}
            <div className="flex justify-center mb-3">
              <span
                className="inline-block border border-gray-300 text-gray-400 text-[10px] md:text-xs px-4 md:px-5 py-1 rounded-full tracking-widest"
                style={{ fontFamily: "'Noto Sans KR', sans-serif", letterSpacing: '0.15em' }}
              >
                평형 선택
              </span>
            </div>

            {/* 타이틀 */}
            <h2
              className="text-xl md:text-4xl font-bold text-center mb-8 md:mb-10"
              style={{ fontFamily: "'Noto Serif KR', serif", letterSpacing: '-0.01em', color: '#1a2a5e' }}
            >
              원하시는 타입을 선택하세요
            </h2>

            {/* Tabs */}
            <div className="flex flex-wrap justify-center gap-2 mb-8 md:mb-10">
              {floorPlans.map((plan) => (
                <button
                  key={plan.id}
                  onClick={() => setSelectedType(plan.id)}
                  className={`px-4 md:px-6 py-1.5 md:py-2 rounded-full text-xs md:text-sm border transition-all whitespace-nowrap cursor-pointer ${
                    selectedType === plan.id
                      ? 'bg-[#1a2a5e] text-white border-[#1a2a5e] font-semibold'
                      : 'bg-white text-gray-500 border-gray-300 hover:border-[#1a2a5e] hover:text-[#1a2a5e] font-normal'
                  }`}
                  style={{ fontFamily: "'Noto Sans KR', sans-serif", fontSize: '11px' }}
                >
                  {plan.label}
                </button>
              ))}
            </div>

            {/* Detail Card */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-xl overflow-hidden shadow-md border border-gray-200">
              {/* Left: Floor Plan Image */}
              <div className="bg-white p-4 md:p-8 flex flex-col">
                <div className="flex items-center justify-between mb-3 md:mb-4">
                  <span
                    className="text-xs md:text-sm text-gray-500 font-medium"
                    style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                  >
                    {selectedPlan.label} 평면도
                  </span>
                  <button
                    onClick={() => setEnlarged(true)}
                    className="flex items-center gap-1 text-[10px] md:text-xs text-[#1a2a5e] border border-[#1a2a5e] px-2 md:px-3 py-1 rounded-full hover:bg-[#1a2a5e] hover:text-white transition-all cursor-pointer whitespace-nowrap"
                    style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                  >
                    <i className="ri-zoom-in-line text-xs"></i>
                    <span>크게 보기</span>
                  </button>
                </div>
                <div className="flex-1 flex items-center justify-center bg-gray-50 rounded-lg overflow-hidden min-h-[280px] md:min-h-[520px]">
                  <img
                    src={selectedPlan.planImg}
                    alt={`${selectedPlan.label} 평면도`}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>

              {/* Right: Info Card */}
              <div className="bg-[#1a2a5e] p-5 md:p-8 flex flex-col justify-between">
                <div>
                  {/* 타입 제목 */}
                  <div className="mb-4 md:mb-5 pb-4 md:pb-5 border-b border-white/20">
                    <p
                      className="text-white/50 text-xs md:text-xs mb-2 tracking-widest uppercase"
                      style={{ fontFamily: "'Noto Sans KR', sans-serif", letterSpacing: '0.15em' }}
                    >
                      FLOOR PLAN TYPE
                    </p>
                    <div className="flex items-baseline gap-2 mb-2 md:mb-3">
                      <span
                        className="text-3xl md:text-5xl font-bold text-white"
                        style={{ fontFamily: "'Noto Serif KR', serif" }}
                      >
                        {selectedPlan.size}
                      </span>
                      <span
                        className="text-2xl md:text-2xl font-light text-white/80"
                        style={{ fontFamily: "'Noto Serif KR', serif" }}
                      >
                        m²
                      </span>
                      <span
                        className="text-2xl md:text-2xl font-bold text-yellow-400 ml-1"
                        style={{ fontFamily: "'Noto Serif KR', serif" }}
                      >
                        {typeLabel}타입
                      </span>
                    </div>
                    <div className="flex items-center gap-2 md:gap-3">
                      <span
                        className="inline-flex items-center gap-1.5 bg-white/10 text-white/80 text-xs px-2 md:px-3 py-1 md:py-1.5 rounded-full"
                        style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                      >
                        <i className="ri-building-line text-xs"></i>
                        총 {selectedPlan.totalUnits}세대
                      </span>
                      <span
                        className="inline-flex items-center gap-1.5 bg-yellow-400/20 text-yellow-300 text-xs px-2 md:px-3 py-1 md:py-1.5 rounded-full"
                        style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                      >
                        <i className="ri-home-line text-xs"></i>
                        {selectedPlan.units}세대 · {selectedPlan.ratio}
                      </span>
                    </div>
                  </div>

                  {/* Area Table */}
                  <div>
                    <p
                      className="text-white/60 text-xs md:text-xs mb-2 md:mb-3 tracking-widest"
                      style={{ fontFamily: "'Noto Sans KR', sans-serif", letterSpacing: '0.2em' }}
                    >
                      면 적 정 보
                    </p>
                    <div className="bg-white rounded-xl overflow-hidden shadow-lg">
                      {[
                        {
                          label: '전용면적',
                          icon: 'ri-home-4-line',
                          value: selectedPlan.areas['전용면적'],
                          highlight: true,
                        },
                        {
                          label: '공급면적',
                          icon: 'ri-layout-line',
                          value: selectedPlan.areas['공급면적'],
                          highlight: false,
                        },
                        {
                          label: '공급면적 (발코니 포함)',
                          icon: 'ri-layout-masonry-line',
                          value: selectedPlan.areas['공급면적발코니'],
                          highlight: false,
                        },
                        {
                          label: '계약면적',
                          icon: 'ri-file-text-line',
                          value: selectedPlan.areas['계약면적'],
                          highlight: true,
                        },
                      ].map((row, i) => (
                        <div
                          key={i}
                          className={`flex items-center justify-between px-3 md:px-5 py-2.5 md:py-4 border-b border-gray-100 last:border-0 ${
                            row.highlight ? 'bg-[#f0f3fa]' : 'bg-white'
                          }`}
                        >
                          <div className="flex items-center gap-2 md:gap-2.5">
                            <div className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full bg-[#1a2a5e]/10">
                              <i className={`${row.icon} text-xs md:text-sm text-[#1a2a5e]`}></i>
                            </div>
                            <span
                              className="text-xs md:text-sm text-gray-600"
                              style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                            >
                              {row.label}
                            </span>
                          </div>
                          <span
                            className={`text-sm md:text-base font-bold ${row.highlight ? 'text-[#1a2a5e]' : 'text-gray-700'}`}
                            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                          >
                            {row.value}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <p
                  className="text-white/30 text-[9px] md:text-[10px] mt-4 md:mt-5 leading-relaxed"
                  style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                >
                  ※ 상기 주택의 설계 변경 등에 따라 변경될 수 있으므로,
                  실제와 다를 수 있습니다.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* All Types Grid */}
        <section className="py-10 md:py-16 px-4 bg-[#f5f6f8]">
          <div className="max-w-5xl mx-auto">
            <h2
              className="text-lg md:text-2xl font-bold text-center text-gray-800 mb-6 md:mb-8"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              전체 타입 한눈에 보기
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
              {floorPlans.map((plan) => (
                <div
                  key={plan.id}
                  onClick={() => {
                    setSelectedType(plan.id);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className={`bg-white rounded-xl overflow-hidden cursor-pointer transition-all border-2 ${
                    selectedType === plan.id
                      ? 'border-[#1a2a5e] shadow-lg'
                      : 'border-transparent shadow hover:shadow-md hover:border-gray-300'
                  }`}
                >
                  <div className="p-3 md:p-5">
                    <div className="text-center mb-3 md:mb-4">
                      <p
                        className="text-sm md:text-base font-bold text-[#1a2a5e]"
                        style={{ fontFamily: "'Noto Serif KR', serif" }}
                      >
                        {plan.label}
                      </p>
                      <p
                        className="text-[10px] md:text-xs text-gray-400 mt-1"
                        style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                      >
                        전용 {plan.areas['전용면적']}
                      </p>
                    </div>
                    <div className="aspect-square w-full bg-gray-50 rounded-lg overflow-hidden flex items-center justify-center">
                      <img
                        src={plan.planImg}
                        alt={`${plan.label} 평면도`}
                        className="w-full h-full object-contain p-2 md:p-3"
                      />
                    </div>
                    <div className="mt-2 md:mt-3 text-center">
                      <span
                        className={`inline-block text-xs px-2 md:px-3 py-1 rounded-full ${
                          selectedType === plan.id
                            ? 'bg-[#1a2a5e] text-white'
                            : 'bg-gray-100 text-gray-500'
                        }`}
                        style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                      >
                        {selectedType === plan.id ? '선택됨' : '선택하기'}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-12 md:py-24 bg-[#0a1229] overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <img
              src="https://readdy.ai/api/search-image?query=elegant%20geometric%20pattern%20luxury%20background%20subtle%20lines%20modern%20architectural%20blueprint%20style%20navy%20blue%20monochrome%20minimalist%20design&width=1920&height=800&seq=cta-pattern-bg-001&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
            <div className="inline-block px-3 md:px-4 py-1 md:py-1.5 bg-yellow-400/20 rounded-full mb-4 md:mb-6">
              <span
                className="text-yellow-400 text-xs md:text-sm font-semibold tracking-wider"
                style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
              >
                CENTRAL CHEONGJU
              </span>
            </div>
            <h2
              className="text-xl md:text-5xl font-bold text-white mb-4 md:mb-6"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              센트럴 청주의 특권,
              <br className="md:hidden" /> 지금 바로 확인하세요
            </h2>
            <p
              className="text-sm md:text-lg text-gray-300 mb-6 md:mb-12 leading-relaxed"
              style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
            >
              가경동 최고의 입지와 프리미엄 설계가 만나
              <br className="hidden md:block" />
              당신의 라이프스타일을 완성합니다
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center mb-8 md:mb-12">
              <Link
                to="/reservation"
                onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
                className="inline-flex items-center justify-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-yellow-400 text-gray-900 rounded-lg font-bold text-sm md:text-base hover:bg-yellow-300 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
                style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
              >
                <i className="ri-calendar-check-line text-lg md:text-xl"></i>
                견본주택 방문 예약
              </Link>
              <a
                href="tel:1555-5475"
                onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
                className="inline-flex items-center justify-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-white/10 text-white rounded-lg font-bold text-sm md:text-base hover:bg-white/20 transition-all border border-white/20 whitespace-nowrap"
                style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
              >
                <i className="ri-phone-line text-lg md:text-xl"></i>
                분양 문의 전화
              </a>
            </div>
            <div
              className="text-xs md:text-base text-gray-400 space-y-1"
              style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
            >
              <p>상담 운영시간: 10:00 - 18:00 (연중무휴)</p>
              <p>견본주택: 충청북도 청주시 흥덕구 비하동 35-28</p>
            </div>
          </div>
        </section>
      </div>

      {/* Enlarged Modal */}
      {enlarged && (
        <div
          className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
          onClick={() => setEnlarged(false)}
        >
          <div
            className="relative max-w-4xl w-full bg-white rounded-xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-4 md:px-5 py-2 md:py-3 border-b border-gray-200">
              <span
                className="text-xs md:text-sm font-semibold text-gray-700"
                style={{ fontFamily: "'Noto Serif KR', serif" }}
              >
                {selectedPlan.label} 평면도
              </span>
              <button
                onClick={() => setEnlarged(false)}
                className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer"
              >
                <i className="ri-close-line text-base md:text-lg text-gray-600"></i>
              </button>
            </div>
            <div className="p-4 md:p-6 bg-gray-50">
              <img
                src={selectedPlan.planImg}
                alt={`${selectedPlan.label} 평면도 확대`}
                className="w-full h-auto object-contain max-h-[70vh]"
              />
            </div>
          </div>
        </div>
      )}

      {/* 모바일 고정 플로팅 CTA 바 */}
      <div className="fixed bottom-0 left-0 right-0 z-[90] md:hidden">
        <div className="h-[2px] bg-gradient-to-r from-[#b8972a] via-[#f0d060] to-[#b8972a] cta-glow"></div>
        <div className="bg-gradient-to-r from-[#0a1229] via-[#1a2b5c] to-[#0a1229] px-3 py-3 flex items-center gap-2.5 shadow-2xl">
          <Link
            to="/reservation"
            onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
            className="flex-1 flex items-center justify-center gap-2 py-3.5 rounded-xl whitespace-nowrap cursor-pointer relative overflow-hidden group cta-pulse"
            style={{ background: 'linear-gradient(135deg, #b8972a 0%, #f0d060 40%, #c9a84c 70%, #b8972a 100%)' }}
          >
            <div className="absolute inset-0 bg-white/0 group-active:bg-white/10 transition-all"></div>
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 bottom-0 w-1/3 bg-gradient-to-r from-transparent via-white/40 to-transparent cta-shimmer"></div>
            </div>
            <i className="ri-calendar-check-line text-[#0a1229] text-[18px] relative z-10"></i>
            <span className="text-[14px] font-bold text-[#0a1229] relative z-10">방문예약</span>
          </Link>
          <a
            href="tel:1555-5475"
            onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
            className="flex-1 flex items-center justify-center gap-2 py-3.5 bg-white rounded-xl whitespace-nowrap cursor-pointer relative overflow-hidden group border-2 border-white/30"
          >
            <div className="absolute inset-0 bg-[#1a2b5c]/0 group-active:bg-[#1a2b5c]/10 transition-all"></div>
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 bottom-0 w-1/3 bg-gradient-to-r from-transparent via-[#1a2b5c]/15 to-transparent cta-shimmer" style={{ animationDelay: '1.1s' }}></div>
            </div>
            <i className="ri-phone-fill text-[#1a2b5c] text-[18px] relative z-10"></i>
            <span className="text-[14px] font-bold text-[#1a2b5c] relative z-10">전화상담</span>
          </a>
        </div>
      </div>

      <Footer />
    </>
  );
}
